export default "<div class=\"description\">\n  {{description}}\n</div>\n"